import React, { ReactElement } from 'react';
import { Steps as AntSteps } from 'antd';
import styled, { keyframes } from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';

interface StepsProps {
  steps: StepSettings[];
  current: number;
  onChange: (current: number) => void;
}

type StepStatus = 'wait' | 'process' | 'finish' | 'error' | undefined;

interface StepSettings {
  title: PlainText;
  status?: StepStatus;
  id?: string;
}

function Steps({ steps, current, onChange }: StepsProps): ReactElement {
  return (
    <StyledSteps current={current} onChange={onChange}>
      {steps.map((step, index) => {
        return (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          <StyledSteps.Step key={index} title={step.title} id={step.id} status={step.status} />
        );
      })}
    </StyledSteps>
  );
}

const animation = keyframes`
  0% {
    transform: scale(2);
   ;
  }
  50% {
   ;
  }
  100% {
    transform: scale(3);
  }
`;

const StyledSteps = styled(AntSteps)`
  margin-left: -5px !important;

  .ant-steps-item-title {
    color: ${colorsPalette.gray300} !important;
  }
  .ant-steps-item:first-child {
    padding-inline-start: 5px !important;
  }

  .ant-steps-item {
    padding: 5px;
    color: ${colorsPalette.gray300} !important;
  }

  .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) {
    .ant-steps-item-container[role='button']:hover .ant-steps-item-icon {
      transform: scale(1.2);
    }
  }

  .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) {
    .ant-steps-item-container[role='button'] .ant-steps-item-icon {
      transition: transform 300ms ease-in-out;
    }
  }

  .ant-steps-item-wait {
    .ant-steps-item-icon {
      background-color: ${colorsPalette.white}!important;
      border-color: ${colorsPalette.gray300}!important;
    }
  }

  .ant-steps-item-finish {
    .ant-steps-item-icon {
      background-color: ${colorsPalette.white} !important;
    }
  }
`;

export { type StepSettings, Steps };
